"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionError = void 0;
class ConnectionError extends Error {
    constructor(msg) {
        super(msg ? `ConnectionError: ${msg}` : "ConnectionError");
    }
}
exports.ConnectionError = ConnectionError;
//# sourceMappingURL=ConnectionError.js.map